'use client';

import { FunctionComponent } from 'react';

import { Link } from '@/react/components/core-ui/Link';
import {
  Icon,
  IconSizeProp,
  type IconTypes
} from '@/react/components/core-ui/Icon';

import S from './styles.module.scss';

export interface ICountryLinkProps {
  /**
   * The link href for the country link.
   */
  link: URL;
  /**
   * The display name for the link.
   */
  name: string;
  /**
   * The country used to get the flag.
   */
  flag: IconTypes;
}

/**
 * The link and icon used to link to a new locale.
 */
export const CountryLink: FunctionComponent<ICountryLinkProps> = ({
  link,
  name,
  flag
}) => {
  return (
    <div className={S.container}>
      <Link href={link} variant="text" className={S.link}>
        <span className={S.icon}>
          <Icon icon={flag} size={IconSizeProp.SizeLG} />
        </span>
        {name}
      </Link>
    </div>
  );
};
